var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[_c('ul',{staticClass:"container__label"},_vm._l((_vm.sortedLabels),function(label,i){return _c('li',{key:i},[(i != 0)?_c('span',{staticClass:"container__label-dot"}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"container__label-title"},[_vm._v(_vm._s(label.fields.title))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }